import { ArrowTopRightIcon } from "@radix-ui/react-icons";
import type { ComponentPropsWithoutRef } from "react";

export function TextLink({ children, className = "", ...props }: ComponentPropsWithoutRef<"a">) {
  return (
    <a className={`text-link ${className}`} {...props}>
      <span>{children}</span>
      <ArrowTopRightIcon aria-hidden="true" focusable="false" />
    </a>
  );
}
